module.exports = "/build/admin/images/smalltile.48b0c177.png";